import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobanglorecab() {



    const cardData = {

keyword: "Mumbai to Bangalore Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Bangalore Cab services for business travelers, families, corporate clients, tourists, students, and long-distance outstation passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth interstate journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, multi-city travel plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable road trip to Bangalore, India's Silicon Valley, known for its pleasant climate, technology parks, royal heritage, gardens, shopping districts, and vibrant cultural attractions.",

topPlaces: [
    {
        title: "Bangalore Palace",
        description:
            "Bangalore Palace is one of the city's most iconic landmarks and showcases magnificent Tudor-style architecture inspired by England's Windsor Castle. The palace features elegant interiors, royal courtyards, vintage photographs, intricate wood carvings, and beautifully landscaped gardens. Visitors can explore the rich history of the Wadiyar dynasty while admiring one of Bangalore's most impressive heritage attractions."
    },
    {
        title: "Lalbagh Botanical Garden",
        description:
            "Lalbagh Botanical Garden is a world-famous garden spread across hundreds of acres and is home to thousands of plant species from India and around the globe. The garden features a stunning glass house, beautiful lakes, rare trees, flower shows, and walking trails. Nature lovers, photographers, and families enjoy spending time amidst its peaceful and scenic environment."
    },
    {
        title: "Cubbon Park",
        description:
            "Cubbon Park is a vast green oasis in the heart of Bangalore, offering tree-lined avenues, landscaped lawns, heritage buildings, and recreational spaces. Visitors enjoy morning walks, cycling, photography, and relaxing amidst nature while escaping the city's busy atmosphere. The park remains one of Bangalore's most popular attractions for both residents and tourists."
    },
    {
        title: "ISKCON Temple Bangalore",
        description:
            "ISKCON Temple Bangalore is one of the largest Krishna temples in the world and attracts devotees and tourists throughout the year. The temple is admired for its grand architecture, spiritual atmosphere, devotional programs, and cultural activities. Visitors experience peaceful surroundings while participating in prayers and exploring the beautifully maintained temple complex."
    },
    {
        title: "Vidhana Soudha",
        description:
            "Vidhana Soudha is an architectural masterpiece and one of Karnataka's most recognizable landmarks. The massive granite structure houses the state legislature and reflects a blend of traditional and modern architectural styles. Visitors admire its grandeur, especially when illuminated in the evening, making it an important sightseeing destination in Bangalore."
    },
    {
        title: "Bannerghatta Biological Park",
        description:
            "Bannerghatta Biological Park is a major wildlife attraction featuring a safari park, zoo, butterfly park, and rescue center. Visitors can observe lions, tigers, bears, elephants, and numerous other species in natural surroundings. The park provides an exciting and educational experience for families, wildlife enthusiasts, and children."
    },
    {
        title: "Tipu Sultan's Summer Palace",
        description:
            "Tipu Sultan's Summer Palace is a historic monument known for its elegant Indo-Islamic architecture, wooden pillars, decorative arches, and royal heritage. Built during the reign of Tipu Sultan, the palace offers valuable insight into Bangalore's historical significance and attracts visitors interested in culture and history."
    },
    {
        title: "Nandi Hills",
        description:
            "Nandi Hills is one of the most popular destinations near Bangalore and is famous for its spectacular sunrise views, cool climate, scenic landscapes, and historical sites. Travelers enjoy trekking, cycling, photography, and exploring ancient temples while experiencing breathtaking views of the surrounding countryside."
    },
    {
        title: "Commercial Street",
        description:
            "Commercial Street is one of Bangalore's most vibrant shopping destinations, offering everything from fashion apparel and footwear to jewelry, handicrafts, and local products. Visitors enjoy shopping, dining, and experiencing the lively atmosphere of this bustling marketplace that attracts people from across the city."
    },
    {
        title: "Ulsoor Lake",
        description:
            "Ulsoor Lake is one of Bangalore's largest and most picturesque lakes, offering boating facilities, walking paths, and scenic island views. The peaceful surroundings provide an excellent place for relaxation, photography, and evening outings. The lake serves as a refreshing retreat amidst the urban landscape and is a favorite attraction for visitors exploring Bangalore."
    }
],



services: [
{
name: "Mumbai to Bangalore Cab",
description: "Mumbai Airport Cab offers Mumbai to Bangalore Cab service for comfortable, safe, and affordable long-distance travel between Mumbai and Bangalore. Whether you are travelling for business meetings, corporate assignments, IT industry visits, family vacations, relocation, group tours, educational trips, or personal travel, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth interstate journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickup services from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and nearby locations, ensuring a reliable and hassle-free travel experience to Bangalore."
},
{
name: "Mumbai to Bangalore Taxi",
description: "Book Mumbai to Bangalore Taxi with Mumbai Airport Cab for reliable and convenient interstate transportation. Our experienced drivers, clean AC vehicles, affordable fares, and flexible travel options make every journey comfortable for families, corporate travellers, students, and tourists."
},
{
name: "Mumbai to Bangalore Taxi Fare",
description: "Get affordable Mumbai to Bangalore Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle choices, and cost-effective travel packages for one way and round trip bookings."
},
{
name: "Mumbai to Bangalore Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Bangalore Cab Fare with professional chauffeurs, premium vehicles, dependable service, and flexible travel plans for all types of travellers."
},
{
name: "Cab from Mumbai to Bangalore",
description: "Choose a Cab from Mumbai to Bangalore with Mumbai Airport Cab and enjoy safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles for long-distance travel."
},
{
name: "Mumbai to Bangalore Car Rental",
description: "Book Mumbai to Bangalore Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles for a comfortable and flexible travel experience."
},
{
name: "Mumbai to Bangalore Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Bangalore Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle options suitable for individual, family, and corporate travel."
},
{
name: "Mumbai to Bangalore One Way Cab",
description: "Travel conveniently with Mumbai to Bangalore One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Bangalore Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Bangalore Round Trip Cab packages for business travel, family holidays, extended tours, corporate transportation, and interstate journeys with flexible schedules."
},
{
name: "Mumbai to Bangalore Outstation Cab",
description: "Book Mumbai to Bangalore Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, affordable rates, and customized travel packages."
},
{
name: "Mumbai to Bangalore Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Bangalore Taxi Service with safe transportation, clean AC vehicles, affordable pricing, professional chauffeurs, and dependable customer support throughout the journey."
},
{
name: "Mumbai to Bangalore Car Hire",
description: "Choose Mumbai to Bangalore Car Hire with Mumbai Airport Cab for premium chauffeur-driven transportation featuring comfortable seating, flexible schedules, and personalized travel service."
},
{
name: "Mumbai to Bangalore Long Distance Cab",
description: "Mumbai Airport Cab specializes in Mumbai to Bangalore Long Distance Cab services with experienced interstate drivers, comfortable vehicles, route planning assistance, and reliable travel arrangements."
},
{
name: "Mumbai to Bangalore Overnight Cab",
description: "Book Mumbai to Bangalore Overnight Cab with Mumbai Airport Cab for convenient overnight travel, professional chauffeurs, comfortable vehicles, and safe transportation across states."
},
{
name: "Mumbai to Bangalore SUV Cab",
description: "Mumbai Airport Cab provides Mumbai to Bangalore SUV Cab service for larger families, business teams, and groups seeking spacious interiors, premium comfort, and ample luggage capacity."
},
{
name: "Mumbai to Bangalore Innova Cab",
description: "Book Mumbai to Bangalore Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, professional chauffeur service, and reliable long-distance transportation."
},
{
name: "Mumbai Airport to Bangalore Cab",
description: "Book Mumbai Airport to Bangalore Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Bangalore Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Bangalore Cab service with doorstep pickup, affordable fares, premium vehicles, and reliable interstate transportation for business and leisure travellers."
},
{
name: "Thane to Bangalore Cab",
description: "Choose Thane to Bangalore Cab with Mumbai Airport Cab for reliable transportation, professional drivers, comfortable vehicles, and flexible travel schedules designed for a smooth long-distance journey."
}
],

tableData: [
["Mumbai to Bangalore Cab","Mumbai to Bangalore Taxi"],
["Mumbai to Bangalore Taxi Fare","Mumbai to Bangalore Cab Fare"],
["Cab from Mumbai to Bangalore","Mumbai to Bangalore Car Rental"],
["Mumbai to Bangalore Cab Booking","Mumbai to Bangalore One Way Cab"],
["Mumbai to Bangalore Round Trip Cab","Mumbai to Bangalore Outstation Cab"],
["Mumbai to Bangalore Taxi Service","Mumbai to Bangalore Car Hire"],
["Mumbai to Bangalore Long Distance Cab","Mumbai to Bangalore Overnight Cab"],
["Mumbai to Bangalore SUV Cab","Mumbai to Bangalore Innova Cab"],
["Mumbai Airport to Bangalore Cab","Navi Mumbai to Bangalore Cab"],
["Thane to Bangalore Cab","Mumbai to Bangalore Corporate Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Bangalore Cab Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Bangalore Cab transportation for business travelers, families, professionals, students, and long-distance travelers seeking a comfortable journey."
},
{
WhyChooseheading: "Convenient Interstate Travel Solution",
WhyChoosedescription: "Our cab service offers hassle-free connectivity between Mumbai and Bangalore for corporate travel, relocation, family visits, educational purposes, and leisure trips."
},
{
WhyChooseheading: "Perfect for Corporate and IT Professionals",
WhyChoosedescription: "Bangalore is India's leading IT and technology hub, and many professionals choose our cab service for meetings, projects, conferences, and business travel."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day travel, or a customized itinerary, we provide flexible booking solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Long-Distance Travel",
WhyChoosedescription: "Our experienced chauffeurs and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey throughout the route."
},
{
WhyChooseheading: "Suitable for Families and Group Travelers",
WhyChoosedescription: "From solo travelers to large groups, we provide suitable vehicle options for vacations, corporate travel, family functions, and special occasions."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Bangalore Cabs?",
answer: "Bangalore is a major IT, business, educational, and technology hub that attracts professionals, students, entrepreneurs, and tourists from Mumbai."
},
{
question: "Can I book a one-way cab from Mumbai to Bangalore?",
answer: "Yes, one-way cab services are available along with round-trip and customized interstate travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Bangalore travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for comfortable long-distance travel."
},
{
question: "Do you provide multi-day cab packages?",
answer: "Yes, customers can book multi-day travel packages according to their schedule and travel requirements."
},
{
question: "Can corporate travelers use this service regularly?",
answer: "Yes, many IT professionals, executives, and business travelers use Mumbai Airport Cabs for official travel to Bangalore."
},
{
question: "Are Tempo Travellers available for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for corporate teams, family groups, and group transportation."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can multiple stops be added during the journey?",
answer: "Yes, customers can customize their itinerary and include sightseeing locations, business destinations, restaurants, and personal stops."
},
{
question: "Is advance booking recommended for Mumbai to Bangalore travel?",
answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
},
{
question: "How can I book a Mumbai to Bangalore Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal Desai",
feedback:
"My business trip to Bangalore was managed perfectly. The vehicle was comfortable for long-distance travel and the driver maintained excellent professionalism throughout the journey.",
rating: 5
},
{
id: 2,
name: "Mrs. Nandini Rao",
feedback:
"Mumbai Airport Cabs delivered a seamless travel experience for our family relocation trip. The cab was spacious, clean, and the entire journey was completed comfortably.",
rating: 5
}
];






































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Bangalore Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-bangalore-cab.jpg",
"description": "Book Mumbai to Bangalore cab service for safe, comfortable, and long-distance travel. Mumbai Airport Cabs offers reliable intercity taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options between Mumbai and Bangalore.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-bangalore-cab"
}
};







    return (
        <div>





<Helmet>
  <title>Mumbai to Bangalore Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Bangalore cab service at affordable fares. Reliable long-distance taxi service with professional drivers, comfortable cars, and one-way and round-trip travel options."
/>

<meta
 name="keywords"
 content="mumbai to bangalore cab, mumbai to bangalore taxi, mumbai to bangalore taxi fare, mumbai to bangalore cab fare, cab from mumbai to bangalore, mumbai to bangalore car rental, mumbai to bangalore cab booking, mumbai to bangalore one way cab, mumbai to bangalore round trip cab, mumbai to bangalore outstation cab, mumbai to bangalore taxi service, bangalore cab from mumbai, long distance cab mumbai to bangalore, best cab service mumbai to bangalore"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobanglorecab;